// removed by extract-text-webpack-plugin
module.exports = {"PromoSlider":"PromoSlider","PromoSlider__item":"PromoSlider__item","slick-slide":"slick-slide","slick-prev":"slick-prev","slick-next":"slick-next","slick-dots":"slick-dots"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/promo-slider/styles.css
// module id = 836
// module chunks = 0 1